<template>
  <div v-if="task">
    <box tag="section">
      <header class="d-flex align-items-center">
        <div class="mr-auto">
          <h1 class="mb-3">Airdrop</h1>
          <dates-range :start="task.start" :end="task.end" />
        </div>
        <!--
          <div>
            <b-row class="cols align-items-center">
              <b-col>
                <span>{{ $t('participantsList') }}:</span>
                <span class="d-flex align-items-center participants-link text-5-alt">
                  <participants :participants="task.participants" />
                  <svg-icon
                    icon="arrow-right"
                    class="icon-xs ml-1" />
                </span>
              </b-col>
              <b-col>
                <button-join
                  :join="task.join"
                  @join="tryJoin"
                  @leave="tryLeave" />
              </b-col>
            </b-row>
          </div>
        -->
      </header>
      <hr />
      <section v-html="task.text"></section>
    </box>
  </div>
</template>

<script>
import taskMixin from './../../mixins/task.js';

export default {
  mixins: [taskMixin]
};
</script>
